import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { ApiService } from '../service/api.service';
import { inject } from '@angular/core';
import { AuthService } from '../service/api/auth/auth.service';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  return router.navigateByUrl('/login');
};

export const authenticationCanMatch: CanMatchFn = (route, segments) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  return router.navigateByUrl('/login');
};
